function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMayaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.55,
    height: 247.89,
    viewBox: "0 0 233.55 247.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Autodesk Maya logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M432.88,388.06v.12c-4.29,2.32-8.39,5-12.59,7.49-8.18,4.89-16.32,9.83-24.49,14.73-.82.29-.52,1.24-.58,1.89q0,86.35,0,172.7c6.89-4,13.68-8.23,20.53-12.31,0,17,0,34,0,51.07a12.65,12.65,0,0,0,10.41,12c3,.43,6.11.11,9.16.21q96.71,0,193.42,0,0-104.56,0-209.11-8.59,0-17.17,0c0-8.89,0-17.78,0-26.66-.13-6.12-5.37-11.73-11.52-12C544.33,388,488.6,388.18,432.88,388.06Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.47,427c10.1,0,20.21,0,30.31,0q9.74,38.72,19.42,77.47c2.23-7.73,4.14-15.56,6.25-23.33q7.14-27.06,14.3-54.13H572c0,32.19,0,64.37,0,96.56-7.62.06-15.24,0-22.86,0q-.05-30.41,0-60.82c0-.25-.1-.75-.13-1C543.62,482.37,538.39,503,533,523.62c-7.56,0-15.12,0-22.68,0q-6.69-25.22-13.32-50.46c-1.31-4.63-2.33-9.35-3.8-13.93-.12,21.46,0,42.93-.07,64.39-6.88,0-13.76,0-20.64,0Q472.53,475.3,472.47,427Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.72,616.05c3.53-12.19,7-24.4,10.47-36.59,4.06,0,8.12,0,12.18,0q5.54,18.31,11.05,36.62-4.67,0-9.33,0c-.76-2.67-1.48-5.35-2.27-8-3.64,0-7.27,0-10.9,0-.77,2.65-1.38,5.35-2.08,8Q480.28,616.09,475.72,616.05Zm16.57-30.54c-1.32,5.23-2.48,10.5-3.75,15.74,2.49,0,5,0,7.48,0C494.89,596,493.47,590.79,492.29,585.52Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506,579.45c3.21,0,6.41,0,9.62,0,2.24,5.13,4.45,10.27,6.69,15.4,2.26-5.11,4.41-10.27,6.65-15.39,3.09,0,6.18,0,9.27,0-3.71,7.05-7.37,14.14-11.09,21.19a2.5,2.5,0,0,0-.42,1.38c0,4.68,0,9.36,0,14-3,0-6.09,0-9.14,0,0-4.68,0-9.36,0-14a4.5,4.5,0,0,0-.75-1.94Q511.38,589.78,506,579.45Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.05,616c3.53-12.19,7-24.4,10.49-36.6,4.07,0,8.13,0,12.2,0,3.62,12.22,7.37,24.4,11,36.62-3.11,0-6.21,0-9.32,0-.72-2.68-1.48-5.35-2.25-8-3.66,0-7.32,0-11,0-.61,2.67-1.36,5.31-2,8C541.13,616.08,538.09,616.09,535.05,616Zm12.8-14.8c2.51,0,5,0,7.52,0-1.18-5.24-2.55-10.45-3.74-15.7C550.25,590.77,549.18,596,547.85,601.25Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.88,388.06c55.72.13,111.45,0,167.17.06,6.16.27,11.39,5.87,11.52,12,0,8.89,0,17.78,0,26.66q0,67.73,0,135.47-89.31.12-178.61,0c-.13-58,0-116.07-.09-174.11Zm39.59,39q0,48.28,0,96.57c6.88.05,13.76,0,20.64,0,.1-21.46,0-42.93.07-64.39,1.46,4.58,2.49,9.3,3.8,13.93q6.65,25.24,13.32,50.46c7.56,0,15.12,0,22.68,0,5.43-20.6,10.66-41.25,16.11-61.84,0,.25.1.75.13,1q0,30.41,0,60.82c7.62,0,15.24,0,22.86,0,0-32.19,0-64.37,0-96.56H542.76q-7.17,27.06-14.3,54.13c-2.11,7.77-4,15.6-6.25,23.33q-9.64-38.75-19.42-77.47C492.68,427,482.58,427,472.47,427Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#39a5cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.3,395.67c4.2-2.48,8.3-5.17,12.59-7.49.13,58,0,116.07.09,174.11l-17.21,10.4c-6.86,4.08-13.64,8.29-20.53,12.31q0-86.35,0-172.7c.06-.65-.24-1.61.58-1.89C404,405.49,412.12,400.55,420.3,395.67Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#7fc5de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.6,426.78q8.59,0,17.17,0,0,104.56,0,209.11-96.71.11-193.42,0c-3.05-.1-6.13.22-9.16-.21a12.65,12.65,0,0,1-10.41-12c0-17,0-34,0-51.07L433,562.28q89.31,0,178.61,0Q611.65,494.51,611.6,426.78ZM475.72,616.05q4.56,0,9.13,0c.7-2.68,1.31-5.37,2.08-8,3.63,0,7.26,0,10.9,0,.78,2.66,1.51,5.35,2.27,8q4.66,0,9.33,0-5.55-18.3-11.05-36.62c-4.06,0-8.12,0-12.18,0C482.7,591.66,479.24,603.86,475.72,616.05ZM506,579.45q5.4,10.33,10.82,20.64a4.5,4.5,0,0,1,.75,1.94c0,4.68,0,9.36,0,14,3,0,6.09,0,9.14,0,0-4.68,0-9.36,0-14a2.5,2.5,0,0,1,.42-1.38c3.72-7.05,7.38-14.14,11.09-21.19-3.09,0-6.18,0-9.27,0-2.24,5.12-4.39,10.28-6.65,15.39-2.23-5.13-4.44-10.27-6.69-15.4C512.41,579.43,509.2,579.45,506,579.45ZM535.05,616c3,0,6.08,0,9.12,0,.64-2.67,1.39-5.3,2-8,3.66-.08,7.32,0,11,0,.77,2.67,1.53,5.33,2.25,8,3.11,0,6.21,0,9.32,0-3.62-12.22-7.38-24.4-11-36.62-4.07,0-8.13,0-12.2,0C542,591.64,538.58,603.86,535.05,616Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#36687f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.29,585.52c1.18,5.27,2.6,10.48,3.73,15.76-2.49,0-5,0-7.48,0C489.81,596,491,590.74,492.29,585.52Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#36687f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.85,601.25c1.33-5.21,2.4-10.48,3.78-15.67,1.19,5.24,2.56,10.45,3.74,15.7C552.87,601.23,550.36,601.27,547.85,601.25Z",
    transform: "translate(-395.22 -388.06)",
    style: {
      fill: "#36687f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayaLogo);
export default __webpack_public_path__ + "static/media/MayaLogo.33c992c768c78cfbc78dc5cc562cea4f.svg";
export { ForwardRef as ReactComponent };